export default "__VITE_ASSET__CBfUzT2v__"